import React from "react";
import "./responsive-assessment.css";
import { Renderhamburgermenu } from "../../../hamburger/hamburger-menu";
import { Row, Col } from "reactstrap";
import "../../begin-questionnaire/begin-questionnaire.css";
import info_black_24dp from "../../../../../images/info_black_24dp.png";
import Popover from "../../../PopOver/Popover";
import RenderReviewPopOver from "../reviewPopOver";
import Renderreponsiveinputrange from "./responsive-input-range";
import { Renderresponsiveoptionnames } from "./responsive-option-names";
import RenderResponsivequestions from "./responsive-question-wrapper";
import { Button } from "reactstrap";
import Rendersuccessmodal from "../submit-assessment-modal/success-modal";
import Renderassessmentmodal from "../submit-assessment-modal";
import Rendermodals from "../../../Modals/modal";


const Responsiveassessmentquestions = ({
  myAssessmentIcon,
  text,
  reviewText,
  defaultQuestionNumber,
  handleQuestionNumber,
  handleInputRange,
  defaultColor,
  handleAssessmentSubmit,
  assessmentModal,
  handleModalClose,
  handleModalSubmit,
  nestedModal,
  handlePrevToNext,
  values,
  value,
  handleReviewAssessment,
  isPopOverVisible,
  overlayIsVisible,
  handleReviewPopOver,
  handleCloseReviewPopOver,
  reviewMode,
  handleReviewAssessmentSubmit,
  handleSaveAndContinue,
  touched,
  questionNumber,
  questionList,
  instrumentOptions,
  runningQuestionId,
  instrumentType,
  assessmentType,
  invitationDetails,
  participant_gender,
  uid,
  myRef,
  isMultiRater,
  participantId,
  min_batch_respondents,
}) => {
  const maxValue =
    instrumentOptions && instrumentOptions.length
      ? instrumentOptions[instrumentOptions.length - 1].option_end_value
      : 0;
  const arrIndex = questionNumber.map((i, index) => {
    return index;
  });
  const arrLength = arrIndex.length;



  return (
    <React.Fragment>
      <div className="responsive-hamburger">

        <Renderhamburgermenu
          link1="/new/app/dashBoard"
          link2="/new/app/dashBoard"
          text1="Dashboard"
          text2="Assessment"
          reviewMode={reviewMode}
        />
      </div>
      <div className="responsive-assessment-wrapper">

        <Row>
          <Col className="d-flex">
            <div className="heading-wrapper " style={{ gap: '10px' }}>
              <img src={myAssessmentIcon} width="20" height="20" />
              <h1 className="responsive-counter-wrapper-text w-auto">
                {reviewMode === false ? text : reviewText}
                {reviewMode === false ? (
                  <span></span>
                ) : (
                  <span>
                    <Popover
                      className="Invitation-popover"
                      positions={["right", "bottom"]}
                      align={"center"}
                      targtElement={<img src={info_black_24dp} alt="info icon" />}
                      isOpen={isPopOverVisible}
                      setOpen={handleReviewPopOver}
                    >
                      <RenderReviewPopOver
                        handleCloseReviewPopOver={handleCloseReviewPopOver}
                      />
                    </Popover>
                  </span>
                )}
              </h1>
            </div>
            {overlayIsVisible && <div className="overlay"></div>}
          </Col>
          <Col>
            <div className="counter-wrapper">
              <p className="responsive-counter-wrapper-text">Question</p>
              <ul>
                {defaultQuestionNumber === arrLength ? (
                  <li style={{ color: "#1a5985" }}>{defaultQuestionNumber}</li>
                ) : (
                  <li>{defaultQuestionNumber}</li>
                )}
                <li style={{ color: "#aaaaaa" }}>{arrLength}</li>
              </ul>
            </div>
          </Col>
        </Row>
        <RenderResponsivequestions
          defaultQuestionNumber={defaultQuestionNumber}
          handleQuestionNumber={handleQuestionNumber}
          reviewMode={reviewMode}
          values={values}
          questionNumber={questionNumber}
          questionList={questionList}
          instrumentOptions={instrumentOptions}
          runningQuestionId={runningQuestionId}
          assessmentType={assessmentType}
          invitationDetails={invitationDetails}
          participant_gender={participant_gender}
          myRef={myRef}
        />
        <div className="align-elements">
          <Renderreponsiveinputrange
            value={parseFloat(value || maxValue / 2)}
            handleInputRange={handleInputRange}
            instrumentOptions={instrumentOptions}
            touched={Boolean(values[defaultQuestionNumber])}
            questionList={questionList}
            instrumentType={instrumentType}
          />
          <div className="rating-box">


            <Renderresponsiveoptionnames
              value={parseFloat(value || maxValue / 2)}
              defaultColor={defaultColor}
              touched={Boolean(values[defaultQuestionNumber])}
              instrumentOptions={instrumentOptions}
              instrumentType={instrumentType}
              questionList={questionList}
            />
          </div>


        </div>

        <div className="d-flex justify-content-between responsiveButtonWrapper">
          <div className="question-button-wrapper question-button-wrapper-responsive w-100">
            <Button
              onClick={handlePrevToNext}
              className={
                defaultQuestionNumber !== 1
                  ? "button-active responsive-active-prev-button"
                  : "button-disabled responsive-disable-prev-button"
              }
              disabled={defaultQuestionNumber === 1}
            >
              Previous
            </Button>
          </div>

          {reviewMode === false ? (
            <div className="question-button-wrapper question-button-wrapper-responsive w-100">
              <Button
                onClick={!touched ? null : handleAssessmentSubmit}
                className={
                  values[defaultQuestionNumber]
                    ? "button-active"
                    : "button-disabled"
                }
              >
                {defaultQuestionNumber === questionNumber.length
                  ? "Submit"
                  : "Next"}
              </Button>
            </div>
          ) : (
            <div className="review-button-wrapper responsive-review-button-wrapper">
              {defaultQuestionNumber === questionNumber.length ? null : (
                <Button type="submit" onClick={handleSaveAndContinue} style={{ width: '150px' }}>
                  Save and Continue
                </Button>
              )}
              <Button onClick={handleReviewAssessmentSubmit} style={{ width: 'fit-content' }}>Submit</Button>
            </div>
          )}
        </div>
        <Rendermodals
          assessmentModal={assessmentModal}
          modalHeading="SUBMIT ASSESSMENT"
          button1="Yes,Review"
          button2="Submit"
          modalConfirmation="Are you sure?"
          modalText="Would you like to review before submitting the assessment?"
          handleModalClose={handleModalClose}
          handleModalSubmit={handleModalSubmit}
        >
          <Renderassessmentmodal
            modalConfirmation="Are you sure?"
            modalText="Would you like to review before submitting the assessment?"
            button1="Yes, Review"
            button2="SUBMIT"
            handleReviewAssessment={handleReviewAssessment}
            handleModalSubmit={handleModalSubmit}
          />
          {assessmentType == "invitations" ? (
            <Rendersuccessmodal
              nestedModal={nestedModal}
              submitButtonText="NEXT"
              modalSuccessMessage="Hooray!"
              modalText={`You have successfully completed assessing ${invitationDetails.user_assessment__participant__full_name}`}
              uid={uid}
              assessmentType={assessmentType}
              invitationDetails={invitationDetails}
              participantId={participantId}
              isMultiRater={isMultiRater}
            />
          ) : (
            <Rendersuccessmodal
              nestedModal={nestedModal}
              submitButtonText="NEXT"
              modalSuccessMessage="Hooray!"
              modalText=" You have successfully completed assessing yourself"
              requestText={
                isMultiRater == false
                  ? ""
                  : "Next, request people who know you well to assess you and submit your LOI"
              }
              uid={uid}
              assessmentType={assessmentType}
              invitationDetails={invitationDetails}
              participantId={participantId}
              isMultiRater={isMultiRater}
              instrumentType={instrumentType}
              min_batch_respondents={min_batch_respondents}
            />
          )}
        </Rendermodals>
        {reviewMode == true &&
          (assessmentType == "invitations" ? (
            <Rendersuccessmodal
              nestedModal={nestedModal}
              submitButtonText="NEXT"
              modalSuccessMessage="Hooray!"
              modalText={`You have successfully completed assessing ${invitationDetails.user_assessment__participant__full_name}`}
              uid={uid}
              assessmentType={assessmentType}
              invitationDetails={invitationDetails}
              participantId={participantId}
              isMultiRater={isMultiRater}
              reviewMode={reviewMode}
            />
          ) : (
            <Rendersuccessmodal
              nestedModal={nestedModal}
              submitButtonText="NEXT"
              modalSuccessMessage="Hooray!"
              modalText=" You have successfully completed assessing yourself"
              uid={uid}
              assessmentType={assessmentType}
              invitationDetails={invitationDetails}
              participantId={participantId}
              isMultiRater={isMultiRater}
              reviewMode={reviewMode}
              min_batch_respondents={min_batch_respondents}
            />
          ))}
      </div>
    </React.Fragment>
  );
};

export default Responsiveassessmentquestions;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/responsive/responsive-assessment-questions.jsx